// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__XgdH9","slider":"Slider_slider__+RTTi"};